import { jsx as e, Fragment as L, jsxs as h } from "react/jsx-runtime";
import { withManagedProps as s } from "@made-people/managed-props";
import { z as n } from "zod";
import { withZod as a } from "@made-people/react-prop-guard";
import { linkStyling as r } from "./index-blueprint.es.js";
import { memo as v } from "react";
import { useLink as C } from "@made-people/grease-link";
import m from "clsx";
import "@made-people/blueprint";
const c = n.object({
  /**
   * The styles object.
   */
  variants: n.custom().optional(),
  /**
   * The link label.
   */
  label: n.custom().optional(),
  className: n.string().optional(),
  onClick: n.function().args(n.any()).returns(n.void()).optional(),
  onMouseEnter: n.function().args(n.any()).returns(n.void()).optional(),
  onMouseOver: n.function().args(n.any()).returns(n.void()).optional(),
  onMouseLeave: n.function().args(n.any()).returns(n.void()).optional(),
  icon: n.custom().or(n.literal(!1)).optional()
}), u = s(
  "LinkContent",
  a(c, ({ label: t, variants: i, icon: l }) => {
    const o = r.styles(i);
    return /* @__PURE__ */ e(L, { children: t && /* @__PURE__ */ h(L, { children: [
      l && /* @__PURE__ */ e("span", { className: o.icon, children: l }),
      /* @__PURE__ */ e("span", { className: o.label, children: t })
    ] }) });
  })
), f = c.merge(
  n.object({
    link: n.object({
      onClick: n.function().args(n.custom()).returns(n.void()).optional(),
      href: n.string().optional()
    }).optional(),
    title: n.string().optional()
  })
), g = v((t) => {
  var o, k;
  const i = C(), l = r.styles(t.variants);
  return /* @__PURE__ */ e(
    i,
    {
      className: m(l.wrapper, t.className),
      href: (o = t.link) != null && o.href ? t.link.href : "",
      title: t.title,
      onClick: (k = t.link) == null ? void 0 : k.onClick,
      onMouseEnter: t == null ? void 0 : t.onMouseEnter,
      onMouseLeave: t == null ? void 0 : t.onMouseLeave,
      children: /* @__PURE__ */ e(u, { ...t })
    }
  );
});
g.displayName = "LinkAsLink";
const M = s(
  "LinkAsLink",
  a(f, g)
), d = c.merge(
  n.object({
    title: n.string().optional()
  })
), A = s(
  "LinkAsSpan",
  a(d, (t) => {
    const i = r.styles(t.variants);
    return /* @__PURE__ */ e(
      "span",
      {
        className: m(i.wrapper, t.className),
        title: t.title,
        onMouseEnter: t.onMouseEnter,
        onMouseOver: t.onMouseOver,
        onClick: t.onClick,
        children: /* @__PURE__ */ e(u, { ...t })
      }
    );
  })
), y = n.discriminatedUnion("as", [
  f.merge(n.object({ as: n.literal("a") })),
  d.merge(n.object({ as: n.literal("span") }))
]), F = s(
  "Link",
  a(y, (t) => t.as === "a" ? /* @__PURE__ */ e(M, { ...t }) : t.as === "span" ? /* @__PURE__ */ e(A, { ...t }) : null)
), N = c.merge(
  n.object({
    title: n.string().optional(),
    onClick: n.function().args(
      n.custom().optional()
    ).returns(n.union([n.void(), n.promise(n.unknown())])).optional()
  })
), P = s(
  "LinkAsButton",
  a(N, (t) => {
    const i = r.styles(t.variants);
    return /* @__PURE__ */ e(
      "button",
      {
        className: m(i.wrapper, t.className),
        title: t.title,
        onClick: t.onClick,
        children: /* @__PURE__ */ e(u, { ...t })
      }
    );
  })
);
export {
  F as Link,
  P as LinkAsButton,
  M as LinkAsLink,
  A as LinkAsSpan,
  u as LinkContent,
  N as linkAsButtonSchema,
  f as linkAsLinkSchema,
  d as linkAsSpanSchema,
  c as linkContentSchema,
  y as linkSchema
};
//# sourceMappingURL=index.es.js.map
